import { StatsGuardServiceInterface } from './service.interface';
import { SecurityGuardFactory } from '../../module/security/guard.factory';
import { StatsGuardRuleHostnameFactory } from '../../module/stats/guard/rule/hostname.factory';

export function StatsGuardService(): StatsGuardServiceInterface {
  const statsGuardService = SecurityGuardFactory();

  // Add rule: stats domain
  statsGuardService.addRule(StatsGuardRuleHostnameFactory());

  return statsGuardService;
}
